import { css, Global } from '@emotion/react'

import {
  fullPageHeightCss,
  normalizeCss,
  pageContainerCss,
  pageResetCss,
  googleFontFacesCss,
} from '@classy/campaign-page-blocks'
import { CLASSY_DESIGN_TOKENS, DEFAULT_THEME } from '@classy/campaign-page-blocks'

const globalResetCss = css`
  :root {
    /* Base tokens */
    ${CLASSY_DESIGN_TOKENS}
    ${DEFAULT_THEME}
  }
  ${normalizeCss}
  ${pageResetCss}
  ${fullPageHeightCss}
  ${googleFontFacesCss}
  body {
    font-family: var(--classy-font__font-family--base);
    ${pageContainerCss}
    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
  #__next {
    overflow-y: auto;
    min-height: 800px;
  }
`

interface AppThemeProps {
  children: React.ReactNode
}

const AppTheme = ({ children }: AppThemeProps) => {
  return (
    <>
      <Global styles={globalResetCss} />
      {children}
    </>
  )
}

export default AppTheme
